export default __webpack_public_path__ + "static/Akash-Sukhani-24caad240159459c79020a3c84ee68d4.jpg";